import { Toaster as Sonner, toast } from "sonner"

const Toaster = ({
  ...props
}) => {
  return (
    <Sonner
      theme="dark"
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-[#1E293B] group-[.toaster]:text-[#F8FAFC] group-[.toaster]:border-[#334155] group-[.toaster]:shadow-lg",
          description: "group-[.toast]:text-[#94A3B8]",
          actionButton:
            "group-[.toast]:bg-[#2563EB] group-[.toast]:text-white",
          cancelButton:
            "group-[.toast]:bg-[#334155] group-[.toast]:text-[#94A3B8]",
        },
      }}
      {...props} />
  );
}

export { Toaster, toast }
